export type VideoAdsState = {
  preRoll?: boolean;
  midRoll?: boolean;
};

export const VIDEO_ADS_INITIAL_STATE: VideoAdsState = {
  preRoll: false,
  midRoll: false,
};
